module.exports = __webpack_public_path__ + "img/vector-pen.183aebff.svg";